export const MenuListTranslationJP = {
  MenuList: {
    HeaderExportCsv: {
      menu_code: 'メニューコード',
      menu_name: 'メニュー名',
      menu_type: 'メニュー種別',
      display_timing: '表示タイミング',
      property: 'プロパティ',
      img_file_name: '画像ファイル名',
      display_name: '表示名',
      display_name_ja: '表示名日本語',
      display_name_en: '表示名英語',
      display_name_vi: '表示名ベトナム語',
      display_name_ko: '表示名韓国語',
      display_name_zh_hant: '表示名中国語(繁体字 )',
      display_name_zh_hans: '表示名中国語（簡体字）',
      explanation: '説明',
      explanation_ja: '説明日本語',
      explanation_en: '説明英語',
      explanation_vi: '説明ベトナム語',
      explanation_ko: '説明韓国語',
      explanation_zh_hant: '説明中国語(繁体字 )',
      explanation_zh_hans: '説明中国語（簡体字）',
      annotation_1: '注釈1',
      annotation1_ja: '注釈1日本語',
      annotation1_en: '注釈1英語',
      annotation1_vi: '注釈1ベトナム語',
      annotation1_ko: '注釈1韓国語',
      annotation1_zh_hant: '注釈1中国語(繁体字 )',
      annotation1_zh_hans: '注釈1中国語（簡体字）',
      annotation_2: '注釈2',
      annotation2_ja: '注釈2日本語',
      annotation2_en: '注釈2英語',
      annotation2_vi: '注釈2ベトナム語',
      annotation2_ko: '注釈2韓国語',
      annotation2_zh_hant: '注釈2中国語(繁体字 )',
      annotation2_zh_hans: '注釈2中国語（簡体字）',
      remarks: '備考',
    },
    ModalImportCsv: {
      btn_cancel: '取り消す',
      btn_save: 'CSVをインポート',
      title: 'メニュー詳細情報CSV取込',
      label: 'CSVファイルのインポート',
      template_link: 'メニュー詳細情報テンプレートダウンロード CSVインポート',
      template_name: 'メニュー詳細情報CSV取込.csv',
    },
    DialogConfirm: {
      btn_cancel: 'キャンセル',
      btn_save: 'OK',
      title: '確認',
      message: '選択されたメニューを削除します。<br/>よろしいですか？',
    },
    Filter: {
      menu_list: 'メニュー一覧',
      filter_condition: '絞り込み条件',
      menu_classification: 'メニュー分類：',
      date_of_expiry: 'レジ情報有効期限',
      date_of_expires: '有効期限',
      pos: 'POSコード',
      show_all: '全て表示',
      show_normal_menu_only: '通常メニューのみ表示',
      show_submenu_only: 'サブメニューのみ表示',
      deleted_data: '削除データ：',
      hide_deleted_data: '削除データ非表示',
      display_include_deleted_data: '  削除データ含めて表示',
      show_deleted_data_only: '削除データのみ表示',
      show_currently_active: '現在有効なものを表示',
      show_currently_disabled: '現在無効なものを表示',
      show_valid_for_the_following_dates: '以下の日付に有効なものを表示',
      search_menu_type_condition: 'サブメニュー属性：',
      regular_menu: '通常メニュー',
      submenu: 'サブメニュー',
      menu_name: 'メニュー名：',
      menu_code: 'メニューコード：',
      properties: 'プロパティ：',
      display_limit: '表示数制限 ：',
      option_all: '全て',
      option_lunch: 'ランチ',
      option_set_meal: '定食',
      age_limit: '年齢制限',
      call_the_clerk: '店員呼出',
      coupon: ' クーポン',
      delete: '削除：',
      show_valid: '有効なものを表示',
      show_deleted: '削除済なものを表示',
      btn_search: '絞り込み',
      service: 'サービス',
      related_cash_register_information: '関連するレジ情報',
      extract_the_menu_from_the_related_cash_register_information: '※関連するレジ情報からメニューを抽出します。',
      selection: '選択',
      display_timing: '表示タイミング：',
      display_timing_menu_search: '表示タイミングメニュー検索',
      display_condition_menu_search: '表示条件メニュー検索',
      display_control_group: '表示制御グループ：',
      control_condition: '制御条件：',
      bar_guidance_menu: 'バー案内対象メニュー：',
      course_target_menu: 'コース対象メニュー：',
      course_set_condition_menu: 'コースセット条件メニュー：',
      guidance_name: '案内名：',
      no_selection: '選択無し',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      import_csv: 'メニュー詳細情報CSV取込',
      export_csv: 'メニュー情報CSV出力 （レジ情報除く）',
      restore: '復元',
    },
    Table: {
      selection: '選択',
      menu_classification: 'メニュー分類',
      menu_code: 'メニューコード',
      classification: '※メニューコード+区分（通常:U、',
      classification_2: '食べ放題:T、クーポン:C）',
      menu_name: 'メニュー名',
      date_of_expiry: 'レジ情報有効期限',
      start: '開始',
      end: '終了',
      menu_type: 'メニュー種別',
      flg: 'サブメニュー属性',
      display_timing: '表示タイミング',
      property: 'プロパティ',
      lunch: 'ランチ',
      set_meal: '定食',
      age_limit: '年齢制限',
      the_clerk_calls_out: '店員呼出',
      coupon: 'クーポン',
      service: 'サービス',
      delivery_timing: '提供タイミング',
      eos: '終売',
      wizard: 'ウィザード',
      pos_information: 'レジ情報',
      validity_period: '有効期間',
      pos_code: 'POSコード',
    },
  },
};
